import { useState, useEffect } from 'react';

export type NoteDetailTabType = 'content' | 'history';

export function useNoteDetailState(noteId?: string) {
  const [activeTab, setActiveTab] = useState<NoteDetailTabType>('content');

  useEffect(() => {
    setActiveTab('content');
  }, [noteId]);

  return { activeTab, setActiveTab };
}
